import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import CryptoJS from "crypto-js";
import { sidebarActions } from "../../../store/sidebar-slice";
import "./SetPassword.css";

export default function SetPasswordPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.user.user);

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  useEffect(() => {
    if (!user) return navigate("/");
    dispatch(sidebarActions.setSidebar(false));
  }, [dispatch]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (password !== confirmPassword) return alert("Passwords do not match");
    axios
      .post("https://x.zocket.com/prod/customer/auth/api/v1/set-new-password", {
        password,
        app_web_business_id: user.app_web_business_id,
      })
      .then(() => {
        alert("New password has been updated");
        navigate("/");
      })
      .catch((error) => {
        alert(JSON.stringify(error));
      });
  };

  return (
    <div id="set-password">
      <h1 className="set-password-heading">Set password for Zocket</h1>
      <p className="set-password-subHeading">
        Set a new password for your account
      </p>
      <div className="set-password-form">
        <form onSubmit={handleSubmit}>
          <div class="form-group">
            <label
              for="exampleInputPassword"
              className="set-password-form-label"
            >
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              className="form-control set-password-form-input"
              id="exampleInputPassword"
              name="password"
              min="8"
              required
            />
          </div>
          <div className="form-group">
            <label
              for="exampleInputConfirmPassword"
              className="set-password-form-label"
            >
              Confirm Password
            </label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(event) => setConfirmPassword(event.target.value)}
              className="form-control set-password-form-input"
              id="exampleInputConfirmPassword"
              name="confirm-password"
              min="8"
              required
            />
          </div>
          <button className="set-password-Btn">Set new password</button>
        </form>
      </div>
    </div>
  );
}
